import { APP_CANDIDATE_DOMAIN } from "src/constants/routes";

export const CANDIDATE_REGISTER = `${APP_CANDIDATE_DOMAIN}/register`;
export const CANDIDATE_DASHBOARD = `${APP_CANDIDATE_DOMAIN}/dashboard`;
export const CANDIDATE_TEST = `${APP_CANDIDATE_DOMAIN}/test/:company_project_id/candidate/:project_candidate_id`;
